module.exports = __webpack_public_path__ + "img/mstile-150x150.db0a7ba2.png";